"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposeMetadata = void 0;
class ExposeMetadata {
    constructor(target, propertyName, options) {
        this.target = target;
        this.propertyName = propertyName;
        this.options = options;
    }
}
exports.ExposeMetadata = ExposeMetadata;
